import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';

var getDisplayName = function getDisplayName(WrappedComponent) {
  var component = WrappedComponent.WrappedComponent || WrappedComponent;
  return component.displayName || component.name || 'Component';
};

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getNodeKey = _ref.getNodeKey,
      getNodeKey = _ref$getNodeKey === void 0 ? function (props) {
    return props.node.key;
  } : _ref$getNodeKey,
      gutterBlockType = _ref.gutterBlockType;

  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(GutterBlockDecorator, _Component);

      function GutterBlockDecorator() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, GutterBlockDecorator);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GutterBlockDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          showGutterBlock: false
        });

        _defineProperty(_assertThisInitialized(_this), "registerGutterBlock", function () {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
          return props.editor.command('registerGutterBlock', {
            nodeId: getNodeKey(props),
            gutterBlockType: gutterBlockType,
            onUpdate: function onUpdate(show) {
              return _this.setState({
                showGutterBlock: show
              });
            }
          });
        });

        _defineProperty(_assertThisInitialized(_this), "unregisterGutterBlock", function () {
          return _this.props.editor.command('unregisterGutterBlock', {
            nodeId: getNodeKey(_this.props),
            gutterBlockType: gutterBlockType
          });
        });

        return _this;
      }

      _createClass(GutterBlockDecorator, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.registerGutterBlock();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (getNodeKey(nextProps) !== getNodeKey(this.props)) {
            this.unregisterGutterBlock();
            this.registerGutterBlock(nextProps);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unregisterGutterBlock();
        }
      }, {
        key: "render",
        value: function render() {
          var showGutterBlock = this.state.showGutterBlock;
          return React.createElement(WrappedComponent, Object.assign({
            showGutterBlock: showGutterBlock
          }, this.props));
        }
      }]);

      return GutterBlockDecorator;
    }(Component), _defineProperty(_class, "propTypes", {
      editor: PropTypes.instanceOf(Editor).isRequired
    }), _defineProperty(_class, "displayName", "GutterBlock(".concat(getDisplayName(WrappedComponent), ")")), _defineProperty(_class, "WrappedComponent", WrappedComponent.WrappedComponent || WrappedComponent), _temp;
  };
});